var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinitIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E0AF5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M24 26.5v5.833M20.667 20.09v1.776c0 .173 0 .26-.017.343a.831.831 0 0 1-.074.211 1.762 1.762 0 0 1-.201.279l-1.308 1.635c-.555.693-.833 1.04-.833 1.332 0 .254.115.494.314.652.228.182.672.182 1.56.182h7.785c.888 0 1.332 0 1.56-.182a.833.833 0 0 0 .313-.652c0-.292-.277-.639-.832-1.332l-1.308-1.635a1.73 1.73 0 0 1-.201-.279.835.835 0 0 1-.074-.211c-.017-.083-.017-.17-.017-.343V20.09c0-.096 0-.144.005-.191a.848.848 0 0 1 .024-.125c.012-.046.03-.09.066-.18l.84-2.099c.245-.612.367-.919.316-1.165a.834.834 0 0 0-.355-.525c-.21-.138-.54-.138-1.2-.138h-6.06c-.66 0-.99 0-1.2.138a.834.834 0 0 0-.355.526c-.05.245.072.552.317 1.164l.84 2.1c.035.089.053.134.066.18.01.04.019.082.023.124.006.047.006.095.006.191Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinitIcon3);
export default __webpack_public_path__ + "static/media/pinit-icon3.5661a75478849c60e1cb03f74c3b1462.svg";
export { ForwardRef as ReactComponent };